<template lang="pug">
mini-shop-container
</template>

<script>
// ----- DO NOT PUT ANY LOGIC HERE ------
// This file is used only for debugging, it's not used for standalone build

import MiniShopContainer from '@/MiniShopContainer'

export default {
  name: 'App',
  components: {
    MiniShopContainer
  }
}
</script>

<style>
.frame {
  border: 1px solid #ced4da;
  border-radius: 0;
  transition: border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;
  padding: 15px;
  width: 50%;
  margin-bottom: 16px;
}

label.form-check-label {
  padding-left: 4px;
}

.frame label.form-check-label {
  padding-left: 8px;
}

div.max-width-container {
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-wrap: nowrap;
}

.minishop {
  max-width: 750px;
  margin: 0 auto;
}
</style>
